import { render, staticRenderFns } from "./error.vue?vue&type=template&id=a5435a0e"
import script from "./error.vue?vue&type=script&lang=js"
export * from "./error.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/chaoangoods.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5435a0e')) {
      api.createRecord('a5435a0e', component.options)
    } else {
      api.reload('a5435a0e', component.options)
    }
    module.hot.accept("./error.vue?vue&type=template&id=a5435a0e", function () {
      api.rerender('a5435a0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/error.vue"
export default component.exports